export default [
  {
    header: 'general.settings',
    resource: ['setting', 'notification'],
    action: 'read',
  },
  {
    title: 'notifications.mainVerticalMenu.notifications',
    icon: 'AlertCircleIcon',
    resource: 'notification',
    action: 'read',
    children: [
      {
        title: 'notifications.mainVerticalMenu.notificationsList',
        route: 'pages-notifications-list',
        resource: 'notification',
        action: 'read',
      },
      {
        title: 'notifications.mainVerticalMenu.notificationAdd',
        route: 'pages-notifications-add',
        resource: 'notification',
        action: 'create',
      },
    ],
  },
  {
    title: 'themeSettings.mainVerticalMenu.themeSettings',
    icon: 'SettingsIcon',
    resource: 'setting',
    action: 'read',
    children: [
      {
        title: 'themeSettings.mainVerticalMenu.themeSettingsList',
        route: 'pages-theme-settings-list',
        resource: 'setting',
        action: 'read',
      },
      {
        title: 'themeSettings.mainVerticalMenu.themeSettingAdd',
        route: 'pages-theme-settings-add',
        resource: 'setting',
        action: 'create',
      },
    ],
  },
  {
    title: 'themeSettings.redirectLink.themeSettings',
    icon: 'SettingsIcon',
    resource: 'setting',
    action: 'read',
    children: [
      {
        title: 'themeSettings.redirectLink.themeSettingsList',
        route: 'pages-redirect-settings-list',
        resource: 'setting',
        action: 'read',
      },
      {
        title: 'themeSettings.redirectLink.themeSettingAdd',
        route: 'pages-redirect-settings-add',
        resource: 'setting',
        action: 'create',
      },
    ],
  },
]
